/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InputPhoneSmallLabel/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import MaskedInput from 'DesignSystem/MaskedInput/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default class InputPhoneSmallLabel extends React.Component {
  render() {
    let { props: {
  children,
  viewPath = "/DesignSystem/InputPhoneSmallLabel",
  marginLeft = 0,
  marginBottom = 0,
  marginTop = 0,
  marginRight = 0,
  label = "Label",
  marginLeftLabel = 10,
  disabled,
  fontSize = 14,
  valueNumber,
  invalidMessage,
  isInvalid,
  onFocus,
  onBlur,
  onChangeValueNumber,
  onKeyUp,
  paddingBottom = 7,
  paddingLeft = 8,
  paddingRight = 8,
  paddingTop = 7,
  innerRef,
  textTransform = "capitalize",
  width = "auto"
  
} } = this
    return (<React.Fragment
>
<div
  data-testid="InputPhoneSmallLabel.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z2hksOa': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-2-Z2hksOa': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mt-3-Z2hksOa': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-4-Z2hksOa': typeof marginRight === 'number' ? `${marginRight}px` : marginRight}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="InputPhoneSmallLabel.Text"
  data-view-path={viewPath}
 style={{'--ml-1-Z2hksOa': typeof marginLeftLabel === 'number' ? `${marginLeftLabel}px` : marginLeftLabel}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
<div
  data-testid="InputPhoneSmallLabel.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<MaskedInput
  viewPath={`${viewPath}/MaskedInput`}
 borderBottomLeftRadius={5}
 borderBottomRightRadius={5}
 borderTopLeftRadius={5}
 borderTopRightRadius={5}
 disabled={disabled}
 fontSize={fontSize}
 initialValue={valueNumber}
 invalidMessage={invalidMessage}
 isInvalid={isInvalid}
 onFocus={onFocus}
 marginLeft={4}
 mask="phone"
 onBlur={onBlur}
 onChange={onChangeValueNumber}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 placeholder="(000) 000-0000"
 ref={innerRef}
 textTransform={textTransform}
 width={width}
/>
</div>
</div>
{children}
</React.Fragment>)
  }
}